var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_139_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.25 35.152C73.249 34.25 72.8903 33.3853 72.2525 32.7475C71.6147 32.1097 70.75 31.751 69.848 31.75C69.4011 31.7488 68.9584 31.8362 68.5455 32.0073C68.1326 32.1784 67.7578 32.4298 67.4427 32.7467L65.2197 34.9697L62.75 37.4395V30.19C65.2902 29.824 67.25 27.6392 67.25 25C67.25 22.105 64.895 19.75 62 19.75H32C29.105 19.75 26.75 22.105 26.75 25V62.5C26.75 62.6989 26.829 62.8897 26.9697 63.0303C27.1103 63.171 27.3011 63.25 27.5 63.25H31.25V65.5C31.25 65.6989 31.329 65.8897 31.4697 66.0303C31.6103 66.171 31.8011 66.25 32 66.25H62C62.1989 66.25 62.3897 66.171 62.5303 66.0303C62.671 65.8897 62.75 65.6989 62.75 65.5V47.0605L70.0303 39.7803L70.8005 39.01C70.4086 40.9593 69.4473 42.7485 68.0382 44.1512L64.4705 47.719L65.531 48.7795L69.0988 45.2118C71.2272 43.0833 72.4175 40.2723 72.4873 37.273C72.9779 36.6748 73.2473 35.9257 73.25 35.152ZM68.5033 33.8073C68.6794 33.6301 68.889 33.4896 69.1198 33.394C69.3506 33.2983 69.5981 33.2494 69.848 33.25C70.3522 33.2508 70.8355 33.4514 71.192 33.808C71.5486 34.1645 71.7492 34.6478 71.75 35.152C71.7506 35.4019 71.7017 35.6494 71.606 35.8802C71.5104 36.111 71.3699 36.3206 71.1927 36.4967L69.5 38.1895L66.8105 35.5L68.5033 33.8073ZM65.75 36.5605L66.5645 37.375L57.125 46.8145L56.3105 46L65.75 36.5605ZM47.9128 56.3522L49.4555 53.266L51.734 55.5445L48.6478 57.0872L47.9128 56.3522ZM50.3105 52L55.25 47.0605L57.9395 49.75L53 54.6895L50.3105 52ZM62 21.25C64.0677 21.25 65.75 22.9323 65.75 25C65.75 27.0677 64.0677 28.75 62 28.75H35.6675C36.1685 28.2624 36.5668 27.6793 36.8387 27.0353C37.1106 26.3912 37.2507 25.6991 37.2507 25C37.2507 24.3009 37.1106 23.6088 36.8387 22.9647C36.5668 22.3207 36.1685 21.7376 35.6675 21.25H62ZM32.75 28.6742V26.5C32.75 26.0868 33.0868 25.75 33.5 25.75H35.6742C35.5257 26.4698 35.1697 27.1303 34.65 27.65C34.1303 28.1697 33.4698 28.5257 32.75 28.6742ZM28.25 61.75V25C28.25 22.9323 29.9323 21.25 32 21.25C32.864 21.2514 33.7011 21.5505 34.3703 22.0969C35.0396 22.6434 35.5001 23.4037 35.6742 24.25H33.5C32.2595 24.25 31.25 25.2595 31.25 26.5V61.75H28.25ZM61.25 64.75H32.75V30.25H61.25V38.9395L57.9395 42.25H35.75V43.75H56.4395L54.9395 45.25H35.75V46.75H53.4395L48.7197 51.4697C48.6652 51.5284 48.6206 51.5955 48.5877 51.6685L48.5795 51.664L46.3295 56.164C46.2592 56.3048 46.235 56.4642 46.2603 56.6195C46.2856 56.7748 46.3592 56.9183 46.4705 57.0295L46.6895 57.25L44.9697 58.9697L46.0303 60.0303L47.75 58.3105L47.9697 58.5303C48.081 58.6416 48.2244 58.7151 48.3797 58.7404C48.5351 58.7657 48.6944 58.7415 48.8353 58.6712L53.3352 56.4212L53.3308 56.413C53.4037 56.3801 53.4709 56.3355 53.5295 56.281L59.5295 50.281L61.25 48.5605V64.75ZM59 48.6895L58.1855 47.875L67.625 38.4355L68.4395 39.25L59 48.6895Z",
    fill: "#867662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75 33.25H58.25V34.75H35.75V33.25ZM35.75 36.25H58.25V37.75H35.75V36.25ZM35.75 39.25H58.25V40.75H35.75V39.25ZM35.75 57.25H44V58.75H35.75V57.25ZM35.75 60.25H58.25V61.75H35.75V60.25Z",
    fill: "#867662"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_139_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 42,
    r: 41.5,
    stroke: "#867662",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_139_4",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_139_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(26 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpIcon);
export default __webpack_public_path__ + "static/media/wp-icon.aa74f8b94adc7d678f49451674421c46.svg";
export { ForwardRef as ReactComponent };